// extracted by mini-css-extract-plugin
module.exports = {"previewer":"Previewer_previewer__3JrKB"};